import { useQuery } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import { POLLING_INTERVAL } from "../key-factory/const";
import { managementSignalsApiQueryKeys } from "../key-factory/queryKeyFactory";

export const useSignalsApiStatusPollingQuery = () => {
    return useQuery({
        enabled: salesSettingsHelper.isSalesApiSignalsEnabled,
        staleTime: Number.POSITIVE_INFINITY,
        queryKey: managementSignalsApiQueryKeys.getStatus(),
        queryFn() {
            return salesApiService.management.getStatus();
        },
        refetchInterval: (query) => {
            // Only refetch if processing is still happening
            return query.state.data?.isDomainsFileProcessing ? POLLING_INTERVAL : false;
        },
    });
};
